import { render, staticRenderFns } from "./ChoiceComponent.vue?vue&type=template&id=3a379602&"
import script from "./ChoiceComponent.vue?vue&type=script&lang=ts&"
export * from "./ChoiceComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAutocomplete,VCard})
